import { getCurrencyCodeParam, getQueryParams } from '../utils/queryUtils';
export const getCurrencyCodeUnit = ({
  countryCode,
  defaultCurrencyCode
}) => {
  if (countryCode !== 'US' && defaultCurrencyCode === 'USD') {
    return 'US$';
  }

  // Returned undefined to for proper type matching with the CurrencyStore type and FormattedIntlCurrency
  return undefined;
};
export const getShowCurrencyCodeUnit = ({
  currencyCode,
  currencyCodeUnit
}) => {
  // We don't want to show the currencyCodeUnit if it is undefined
  return currencyCode === 'USD' && !!currencyCodeUnit;
};
export const getValidatedCurrencyCodeParam = ({
  availableCurrencyCodes
}) => {
  const currencyCodeParam = getCurrencyCodeParam(getQueryParams());
  const upperCaseCurrencyCodeParam = currencyCodeParam === null || currencyCodeParam === void 0 ? void 0 : currencyCodeParam.toUpperCase();
  return upperCaseCurrencyCodeParam && availableCurrencyCodes.includes(upperCaseCurrencyCodeParam) ? upperCaseCurrencyCodeParam : null;
};
export const getDisplayedCurrencyCode = ({
  lockedCurrencyCode,
  defaultCurrencyCode,
  availableCurrencyCodes
}) => {
  const currencyCodeParam = getValidatedCurrencyCodeParam({
    availableCurrencyCodes
  });
  return lockedCurrencyCode || currencyCodeParam || defaultCurrencyCode;
};
export const getCurrencyStoreResponse = response => {
  const {
    countryCode,
    defaultCurrencyCode,
    lockedCurrencyCode,
    availableCurrencyCodes
  } = response;
  const currencyCodeUnit = getCurrencyCodeUnit({
    countryCode,
    defaultCurrencyCode
  });
  const showCurrencyCodeUnit = getShowCurrencyCodeUnit({
    currencyCode: defaultCurrencyCode,
    currencyCodeUnit
  });
  const displayedCurrencyCode = getDisplayedCurrencyCode({
    lockedCurrencyCode,
    defaultCurrencyCode,
    availableCurrencyCodes
  });
  return Object.assign({
    currencyCodeUnit,
    showCurrencyCodeUnit,
    displayedCurrencyCode
  }, response);
};